// Setter tracking presence beat (SPEC §19, 2026-10-01; TRACKING-SPEC-2026-10-01.md §4.2). Owner: tracking agent.
// While the Dialer page is mounted AND (the tab is visible OR a call is live), POST /api/tracking/presence every 30 s and
// at once when the state changes. Failures stay silent to the setter (one console line); nothing is sent on unload
// (sendBeacon can't carry the CSRF header).
import { useEffect } from 'preact/hooks';
import { api } from '../api';
import { getDialer, subscribeDialer } from '../dialer/store';
import { presenceStateOf } from './presence-state';

export { presenceStateOf };

export const BEAT_MS = 30_000;

export function usePresenceBeat(): void {
  useEffect(() => {
    let last: string | null = null;
    let lastAt = 0;
    let warned = false;
    const beat = (force: boolean) => {
      const s = getDialer();
      const state = presenceStateOf(s);
      const visible = typeof document === 'undefined' || document.visibilityState === 'visible';
      if (!visible && state !== 'in_call') return;
      const key = `${state}|${s.campaignId ?? ''}`;
      const now = Date.now();
      if (!force && key === last && now - lastAt < BEAT_MS - 1000) return;
      last = key;
      lastAt = now;
      api.post('/api/tracking/presence', { state, campaignId: s.campaignId ?? null }).catch((e) => {
        if (!warned) { warned = true; console.warn('presence beat failed (tracking only, dialing is unaffected):', e); }
      });
    };
    beat(true);
    const timer = setInterval(() => beat(true), BEAT_MS);
    const unsub = subscribeDialer(() => beat(false));
    const onVis = () => beat(false);
    document.addEventListener('visibilitychange', onVis);
    return () => { clearInterval(timer); unsub(); document.removeEventListener('visibilitychange', onVis); };
  }, []);
}
